<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="bind-card-group">
        <div class="form-item">
          <div class="field-title">{{ $t('setting.band_name') }}</div>
          <van-field class="custom-field" v-model="bank" readonly :placeholder="$t('setting.band_name_tip')" @click="showSelectBanks()" />
        </div>
        <div class="form-item">
          <div class="field-title">{{ $t('setting.band_account') }}</div>
          <van-field class="custom-field" v-model="bankid" type="digit" :placeholder="$t('setting.band_account_tip')" />
        </div>
        <div class="form-item">
          <div class="field-title">{{ $t('setting.username') }}</div>
          <van-field class="custom-field" v-model="username" :placeholder="$t('setting.username_place')" />
        </div>
        <div class="form-item">
          <div class="field-title">{{ $t('setting.money_place') }}</div>
          <van-field class="custom-field" v-model="opw" type="password" :placeholder="$t('setting.money_place')" />
        </div>
        <div class="form-item">
          <div class="field-title">{{ $t('setting.money_again_place') }}</div>
          <van-field class="custom-field" v-model="tpw" type="password" :placeholder="$t('setting.money_again_place')" />
        </div>
        <div class="form-item">
          <div class="field-title">{{ $t('setting.mobile') }}</div>
          <van-field class="custom-field" v-model="mobile" type="digit" :placeholder="$t('setting.mobile_place')" />
        </div>
      </div>

      <p>{{ $t('setting.bank_warn') }}</p>
    </div>

    <van-button
      class="bindCard"
      :class="{ 'bindCard-active': canSubmit }"
      type="default"
      :disabled="!canSubmit"
      @click="bindCard()"
    >
      {{ $t('setting.bank_ok') }}
    </van-button>

    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }">
      <van-picker
        show-toolbar
        :columns="banks"
        @confirm="onConfirm"
        @cancel="onCancel"
        :confirm-button-text="$t('setting.ok')"
        :cancel-button-text="$t('setting.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank: false,
      userInfo: {},
      bankid: '',
      username: '',
      mobile: '',
      bank: '',
      bank_code: '',
      opw: '',
      tpw: '',
    };
  },
  computed: {
    canSubmit() {
      return !!(
        this.bank &&
        this.bankid &&
        this.username &&
        this.opw &&
        this.tpw &&
        this.mobile &&
        this.opw === this.tpw
      );
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      if (!this.bank || !this.bankid || !this.username || !this.opw || this.opw !== this.tpw || !this.mobile) {
        this.$toast(this.$t('common.complete_info'));
        return false;
      }

      this.$http({
        method: 'post',
        data: {
          bankid: this.bankid,
          bank: this.bank,
          bank_code: this.bank_code,
          username: this.username,
          mobile: this.mobile,
          opw: this.opw,
          tpw: this.tpw,
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: '/Mine' });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    showSelectBanks() {
      this.getBankList();
      this.showBank = true;
    },
    onConfirm(value) {
      this.bank = value.text;
      this.bank_code = value.value;
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getBankList() {
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res => {
        if (res.code === 200) {
          this.banks = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          this.is_bind = res.data.is_bank;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-button {
  position: fixed;
  bottom: 24px;
  left: 10%;
  width: 80%;
  padding: 0;
  font-size: 28px;
}
</style>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.main-box {
  padding: 38px 24px 0;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  padding-bottom: 140px;
}

.van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.bind-card-group {
  overflow: hidden;
  border-radius: 28px;
  padding: 18px 28px 14px;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.14);
}

.form-item {
  padding: 34px 0 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.22);
}

.form-item:last-child {
  border-bottom: none;
}

.field-title {
  margin-bottom: 20px;
  color: #fff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.6;
}

.bankbox {
  padding: 15px;
  color: #000;
}

.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #fff;
}

::v-deep .van-picker__toolbar {
  height: 72px;
}

::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 24px;
  font-size: 30px;
  font-weight: 600;
}

::v-deep .van-picker__toolbar .van-picker__confirm {
  font-size: 30px !important;
  font-weight: 600 !important;
  padding-right: 24px !important;
}

::v-deep .van-picker-column {
  font-size: 40px;
}

::v-deep .nav-bar {
  height: 84px;
}

::v-deep .nav-bar .van-nav-bar__title {
  font-size: 28px;
  font-weight: 700;
  line-height: 84px;
}

::v-deep .nav-bar .van-icon-arrow-left {
  font-size: 34px;
}

.main-box p {
  margin: 24px 6px 0;
  padding: 0;
  font-size: 26px;
  line-height: 1.6;
  color: #ee0a24;
}

.bindCard {
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 40px;
  color: #fff;
  font-size: 26px;
  font-weight: bolder;
  border: none;
  background: #cacacc;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.bindCard-active {
  background: linear-gradient(135deg, #ff8a4c, #ff5f6d);
  box-shadow: 0 12px 24px rgba(255, 95, 109, 0.28);
}

.bindCard[disabled] {
  opacity: 1;
  color: #fff !important;
}

.van-field,
.van-cell-group {
  background: none;
}

::v-deep .custom-field {
  padding: 0;
  background: transparent;
}

::v-deep .custom-field::after {
  display: none;
}

::v-deep .custom-field .van-field__body {
  min-height: 74px;
  padding: 0 14px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.05);
}

::v-deep .custom-field .van-field__control {
  color: #fff !important;
  font-size: 26px;
  line-height: 1.8;
}

::v-deep .custom-field .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.62) !important;
  font-size: 24px;
}
</style>
